
import Vue from 'vue'
import { VImg } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcLogo',
  components: {
    VImg,
  },
})
